<template>
  <v-toolbar app clipped-left height="64em" color="#00476B">
    <img src="@/assets/icons/lpf_icon.png" height="50" class="pointer" @click="goHome">
    <ToolbarLogo></ToolbarLogo>
    <slot></slot>
    <v-spacer></v-spacer>
    <v-toolbar-items>
      <NotificationsMenu></NotificationsMenu>
      <UserMenu></UserMenu>
    </v-toolbar-items>
  </v-toolbar>
</template>

<script>
import ToolbarLogo from './ToolbarLogo'
import UserMenu from '../../../features/account/components/UserMenu'
import NotificationsMenu from '../../../features/notification/components/NotificationsMenu'

export default {
  components: {
    ToolbarLogo,
    UserMenu,
    NotificationsMenu
  },

  methods: {
    goHome () {
      this.$router.push({ name: 'dashboard' })
    }
  }
}
</script>

<style scoped>
  .pointer {
    cursor: pointer;
  }
</style>
